/**
 * NGlow AJAX Cart (Clean Version)
 * Depends on: nglow-license.js for UI updates
 */

function openCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
        drawer.classList.add('active');
        document.body.style.overflow = 'hidden';
    }
}

function closeCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
        drawer.classList.remove('active');
        document.body.style.overflow = '';
    }
}

async function addToCart(variantId, quantity = 1, trigger = null) {
    if (!window.NGlow_Authenticated) return;
    
    if (trigger) trigger.classList.add('loading');
    let success = false;

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
        });
        
        if (response.ok) {
            success = true;
            if (window.NGlow_UpdateCartUI) await window.NGlow_UpdateCartUI();
            openCartDrawer();
        } else {
            const error = await response.json();
            console.error('Add to cart failed:', error.description);
        }
    } catch (error) {
        console.error('AJAX Add to Cart error:', error);
    } finally {
        if (trigger) {
            trigger.classList.remove('loading');
            if (success) {
                trigger.classList.add('added');
                // Lock SVG with stroke animation potential
                trigger.innerHTML = `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>`;
                
                setTimeout(() => {
                    trigger.classList.remove('added');
                    trigger.innerHTML = '+';
                }, 3000);
            }
        }
    }
}

document.addEventListener('NGlow:Ready', () => {
    // Intercept clicks
    document.addEventListener('click', (e) => {
        const target = e.target;
        const addBtn = target.closest('[data-add-to-cart]');
        if (addBtn) {
            e.preventDefault();
            addToCart(addBtn.getAttribute('data-add-to-cart'), 1, addBtn);
        }
        
        const cartIcon = target.closest('.cart-btn');
        if (cartIcon && !window.location.pathname.includes('/cart')) {
            e.preventDefault();
            openCartDrawer();
        }
    });

    // Intercept form submissions
    document.addEventListener('submit', async (e) => {
        const form = e.target.closest('form[action="/cart/add"]');
        if (form) {
            e.preventDefault();
            const formData = new FormData(form);
            try {
                const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
                if (response.ok && window.NGlow_UpdateCartUI) {
                    await window.NGlow_UpdateCartUI();
                    openCartDrawer();
                }
            } catch (error) {
                console.error('Form Add to Cart failed:', error);
            }
        }
    });
});